// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"c8042e9d","300":"c2dcde60","374":"84de94c8","429":"df5dcc09","466":"23237e75","488":"0e24555d","507":"5f524735","801":"80930c78"}[chunkId] + ".chunk.js";
};